/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContactResponseDto } from '../../models/sales-contact-response-dto';
import { SalesReferentUpdateDto } from '../../models/sales-referent-update-dto';

export interface ContactsControllerUpdateReferent$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the contact.
 */
  id: string;

/**
 * The email of the referent to update.
 */
  referentEmail: string;
      body: SalesReferentUpdateDto
}

export function contactsControllerUpdateReferent(http: HttpClient, rootUrl: string, params: ContactsControllerUpdateReferent$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContactResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contactsControllerUpdateReferent.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.path('referentEmail', params.referentEmail, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContactResponseDto>;
    })
  );
}

contactsControllerUpdateReferent.PATH = '/o2-sales/contacts/{tenant}/{id}/referents/{referentEmail}';
